import React from "react";
import { translate } from '../Services/translation';
import Svg from "../Components/Svg";

export default function GoogleMapDropdown(props) {
    const handleCountryChange = (event) => {
        let selectedCountry = event.target.value;
        props.onCountryChange(selectedCountry);
    };

    if (typeof props.countries === 'undefined' || !Object.keys(props.countries).length) {
        return null;
    }

    const sortEmptyLast = function (a, b) {
        return ((a.v.length < b.v.length) ? 1 : ((a.v.length > b.v.length) ? -1 : 0));
    };

    let countryArray = [];

    for (let key in props.countries) {
        let value = props.countries[key] || "";
        countryArray.push({k: key, v: value});
    }

    countryArray = countryArray.sort(sortEmptyLast);

    return (
        <div className="google-map__list__country-dropdown">
            <select className="country-dropdown" id="country-dropdown" onChange={handleCountryChange} value={props.selectedCountry}>
                <option value=''>{translate("googlemap.dropdown.country")}</option>
                {countryArray.map((item) => (
                    <option key={item.k} value={item.k}>
                        {item.v}
                    </option>
                ))}
            </select>
            <label className="google-map__dropdown_chevron" htmlFor="country-dropdown">
                <Svg icon={'chevron-down'}/>
            </label>
        </div>
    );
}
